import { AESCipherSIVDeterministic } from '../../base/cipher/aes';
import { AbstractPeerAccountKeyring, AbstractSelfAccountKeyring } from '../../keyring/account_base';
import { AbstractCryptoConfig } from '../base';
import { AccountMasterDeriveKeyV2 } from '../common';
import { SharedSecretConfigDumpArgs, SharedSecretConfigLoadArgs } from './args';
import { makeInfoByteArray } from '../../utility';
import { CryptoUpgrade } from '../feature';

/**
 * Shared secret encryption: AES-SIV
 *         KEY: 32B from account keyring -> 64B HKDF by context
 *         NONCE: none
 *
 *     NOTE: No LRU cache on derive_key(), each peer will be loaded once or rarely again.
 */
export class SharedSecretConfigV1 extends AbstractCryptoConfig<
  SharedSecretConfigLoadArgs,
  SharedSecretConfigDumpArgs
> {
  constructor(cu: CryptoUpgrade) {
    super(1, cu);
  }

  public load(args: SharedSecretConfigLoadArgs): Promise<Uint8Array> {
    return this.derive_key(args.self_kr, args.peer_kr, args.ss_version).then((derive_key) => {
      return AESCipherSIVDeterministic.decrypt(
        args.cipher.slice(this.version.byteLength),
        derive_key
      );
    });
  }

  public dump(args: SharedSecretConfigDumpArgs): Promise<Uint8Array> {
    return this.derive_key(args.self_kr, args.peer_kr, args.ss_version).then((derive_key) => {
      return AESCipherSIVDeterministic.encrypt(
        args.shared_secret,
        derive_key,
        undefined,
        this.version
      );
    });
  }

  public derive_key(
    self_kr: AbstractSelfAccountKeyring,
    peer_kr: AbstractPeerAccountKeyring,
    ss_version: string
  ) {
    return AccountMasterDeriveKeyV2.derive_key(
      self_kr,
      makeInfoByteArray(['shared-secret-', this.version, '-', ss_version, '-', peer_kr.id]),
      false
    );
  }
}
